import React from "react";
import { UserOutlined, RightOutlined, LeftOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import logo from "../../../assets/logo.png";
import smlogo from "../../../assets/logo-hor.svg";
import { Link } from "react-router-dom";

const { Sider } = Layout;
const DesktopSiderMenu = ({ collapsed, setCollapsed }) => {
  return (
    <Sider
      className="mediumShadow"
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <Link to="/" className="p-2 ">
        <img
          src={collapsed ? smlogo : logo}
          alt="logo"
          className={!collapsed ? `pl-4 pr-8 mt-3  ` : `pr-4 pl-1 mt-2`}
        />
      </Link>
      <span
        onClick={() => setCollapsed(!collapsed)}
        className="absolute -right-4 top-9 bg-primaryColor border border-secondaryColor rounded-full text-secondaryColor p-2 outline outline-1"
      >
        {collapsed ? (
          <RightOutlined className="cursor-pointer" />
        ) : (
          <LeftOutlined className="cursor-pointer" />
        )}
      </span>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={["1"]}
        items={[
          {
            key: "1",
            icon: (
              <Link to="/" className="p-2 ">
                <UserOutlined />
              </Link>
            ),
            label: "Dashboard",
          },
          // {
          //   key: "2",
          //   icon: <VideoCameraOutlined />,
          //   label: "nav 2",
          // },
          // {
          //   key: "3",
          //   icon: <UploadOutlined />,
          //   label: "nav 3",
          // },
        ]}
      />
    </Sider>
  );
};
export default DesktopSiderMenu;
